export default __webpack_public_path__ + "locales/nl/PDFFormDialog.json?hash=426daf2531f92d052d15a55c99e7bf34";